
import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { FileQuestion, HelpCircle, PenTool, ShieldCheck } from 'lucide-react';

const QuickLinks: React.FC = () => {
  const links = [
    { 
      icon: <HelpCircle className="h-4 w-4 mr-2" />,
      title: 'Support Center',
      description: 'Contact our support team',
      action: () => window.open('/master/support', '_self')
    },
    { 
      icon: <FileQuestion className="h-4 w-4 mr-2" />,
      title: 'FAQs',
      description: 'Frequently asked questions',
      action: () => window.open('/master/support?tab=faqs', '_self')
    },
    { 
      icon: <PenTool className="h-4 w-4 mr-2" />,
      title: 'Templates',
      description: 'Edit agreement templates',
      action: () => window.open('/master/settings?tab=agreements', '_self')
    },
    { 
      icon: <ShieldCheck className="h-4 w-4 mr-2" />,
      title: 'Security',
      description: 'Security best practices',
      action: () => window.open('/master/settings?tab=security', '_self')
    }
  ];

  return (
    <Card>
      <CardHeader className="pb-3">
        <CardTitle>Quick Links</CardTitle>
        <CardDescription>Helpful resources</CardDescription>
      </CardHeader>
      <CardContent className="grid gap-2">
        {links.map((link, index) => (
          <Button 
            key={index} 
            variant="outline" 
            className="w-full justify-start text-left" 
            onClick={link.action}
          >
            {link.icon}
            <div>
              <div className="font-medium">{link.title}</div>
              <div className="text-xs text-muted-foreground">{link.description}</div>
            </div>
          </Button>
        ))}
      </CardContent>
    </Card>
  );
};

export default QuickLinks;
